import { render, staticRenderFns } from "./Wonder.vue?vue&type=template&id=73ce7f00&"
import script from "./Wonder.vue?vue&type=script&lang=ts&"
export * from "./Wonder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports